// frontend/src/pages/components/exportJobLabels.ts
//
// Zentrale Anzeige-Labels und Render-Reihenfolgen für die Sperrliste-Export-Jobs (v2).
// Datenmodell v2: quelle (Mehrfachauswahl) x daten (Single-Select) statt werbeweg.
// Reines TS-Modul ohne MUI-Imports — von ExportJobFormDialog und ExportJobsManager genutzt.

// Quelle = Basis-Datenbestand (Mehrfachauswahl, mind. eine Pflicht).
export const QUELLE_LABELS: Record<string, string> = {
  sperrliste: 'Sperrliste',
  boh: 'BOH',
  bok: 'BOK',
};

// Daten = Ausgabe-Spaltenbild (eine Auswahl pro Job).
export const DATEN_LABELS: Record<string, string> = {
  telefon: 'Telefon',
  email: 'E-Mail',
  kunden: 'Kunden',
  kundenanschrift: 'Kundenanschrift',
  matchcode: 'Matchcode (inf3)',
  matchcode_mc17: 'Matchcode (MC17)',
};

// Stabile Render-Reihenfolge für Selects.
export const QUELLE_ORDER: string[] = ['sperrliste', 'boh', 'bok'];
export const DATEN_ORDER: string[] = [
  'telefon',
  'email',
  'kunden',
  'kundenanschrift',
  'matchcode',
  'matchcode_mc17',
];

// Helper mit Fallback auf den Rohwert (falls unbekannter Wert aus dem Backend kommt).
export const quelleLabel = (q: string): string => QUELLE_LABELS[q] || q;
export const datenLabel = (d: string): string => DATEN_LABELS[d] || d;
